export default {
  show: {
    display: 'block'
  },
  hide: {
    display: 'none'
  },
  box: {
    width: '100%',
    height: '100%',
  },
  continer: {
    display: 'block',
    boxSizing: 'border-box',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    width: '60%',
    minHight: '400px',
    zIndex: '9999',
    backgroundColor: '#fff',
    boxShadow: '1px 1px 20px #333'
  },
  tirtle: {
    width: '100%',
    textAlign: 'center',
    padding: '10px 10px',
    borderBottom: '1px solid #eee',
    boxSizing: 'border-box'
  },
  content: {
    width: '100%',
    padding: '10px 10px',
    borderBottom: '1px solid #eee',
    boxSizing: 'border-box'
  },
  foot: {
    width: '100%',
    padding: '10px 10px',
    textAlign: 'right',
    boxSizing: 'border-box'
  },
  boxbg: {
    display: 'block',
    boxSizing: 'border-box',
    position: 'fixed',
    width: '100%',
    height: '100%',
    zIndex: '999',
    top: '0',
    left: '0',
    backgroundColor: 'rgba(0,0,0,0.7)',
  },
  megGroup: {
    display: 'block',
    boxSizing: 'border-box',
    position: 'fixed',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '100%',
    left: '0%',
    zIndex: '9999',
  },
  megStyle: {
    display: 'block',
    boxSizing: 'border-box',
    position: 'relative',
    marginBottom: '10px',
    left: '50%',
    textalign: 'left',
    wordWrap: 'break-word',
    wordBreak: 'break-all',
    resize: 'none',
    verticalAlign: 'top',
    minWidth: '200px',
    maxWidth: '30rem',
    height: 'auto',
    fontSize: '16px',
    padding: '.5rem 1rem',
    backgroundColor: 'rgb(235,248,242)',
    transform: 'translateX(-50%)',
    border: 'solid 1px',
    borderColor: 'rgb(167,225,196)',
    borderRadius: '5px'
  },
  success: {
    backgroundColor: 'rgb(235,248,242)',
    borderColor: 'rgb(167,225,196)',
  },
  warning: {
    backgroundColor: 'rgb(255,250,235)',
    borderColor: 'rgb(255,233,167)',
  },
  error: {
    backgroundColor: 'rgb(254,243,235)',
    borderColor: 'rgb(252,204,167)',
  },
  normal: {
    backgroundColor: 'rgb(235,244,255)',
    borderColor: 'rgb(65,150,252)',
  },
  disabled: {
    cursor: 'not-allowed',
    border: '1px solid #ddd',
    borderColor: '#ddd',
    backgroundColor: '#ddd',
    color: '#aaa'
  },
  leftCon: {
  },
  rightX: {
    position: 'absolute',
    right: '10px',
    top: '5px',
    cursor: 'pointer'
  },
  container: {
    display: 'inline-block',
    padding: '10px',
    margin: '10px 10px'
  },
  spanb: {
    margin: '5px 5px',
    float: 'left',
    padding: '10px',
    backgroundColor: '#ddd',
  },
  marginRight: {
    marginRight: '1rem'
  }
};



// WEBPACK FOOTER //
// ./src/Components/Modal/style.js